var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-carousel"},[_c('el-carousel',_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{attrs:{"src":item.pic,"alt":""}})])}),1)],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap banner-wrap"},[_c('div',{staticClass:"menu-list"})])
}]

export { render, staticRenderFns }